import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from './router/employer';
import { EMPLOYER_BASE_PATH } from './utils/employer/constants';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';
import { IntlProvider } from 'react-intl';

const router = createBrowserRouter(routes, {
  basename: EMPLOYER_BASE_PATH,
});

function App() {
  return (
    // In some cases components might be using useIntl() or FormattedMessage before they are properly
    // loaded. This catch-all, top-level IntlProvider makes sure that the required hooks are always
    // available even if the actual IntlProvider that has the translations is not ready.
    <IntlProvider locale="en" messages={{}} defaultLocale="en">
      <NuqsAdapter>
        <RouterProvider router={router} />
      </NuqsAdapter>
    </IntlProvider>
  );
}

export default App;
